import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=66f13eb3&scoped=true"
import script from "./cardList.vue?vue&type=script&lang=js"
export * from "./cardList.vue?vue&type=script&lang=js"
import style0 from "./cardList.vue?vue&type=style&index=0&id=66f13eb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f13eb3",
  null
  
)

export default component.exports